/**
 * @generated SignedSource<<5bd2edf59c81880465dd26efafc033f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CurrencyType = "CAD" | "EUR" | "USD" | "%future added value";
export type DataGranularity = "MONTHLY" | "WEEKLY" | "%future added value";
export type FbAccessTokenType = "LP" | "%future added value";
export type AdminListBrandsRequest = {
  accountId?: string | null;
  includeArchived?: boolean | null;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type AccountBrandsPanelQuery$variables = {
  input: AdminListBrandsRequest;
};
export type AccountBrandsPanelQuery$data = {
  readonly adminListBrands: {
    readonly data: ReadonlyArray<{
      readonly currencyType: CurrencyType | null;
      readonly dataGranularity: DataGranularity | null;
      readonly fbAccessTokenType: FbAccessTokenType | null;
      readonly featureFlagIds: ReadonlyArray<string>;
      readonly id: string;
      readonly insightsThreshold: number | null;
      readonly metaAdAccountExternalId: string | null;
      readonly minAdSpend: number | null;
      readonly name: string;
    }>;
  };
};
export type AccountBrandsPanelQuery = {
  response: AccountBrandsPanelQuery$data;
  variables: AccountBrandsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminBrandList",
    "kind": "LinkedField",
    "name": "adminListBrands",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminBrand",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaAdAccountExternalId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlagIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencyType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fbAccessTokenType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dataGranularity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minAdSpend",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insightsThreshold",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountBrandsPanelQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountBrandsPanelQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "72b066295c8e88f86f313b0144330fa6",
    "id": null,
    "metadata": {},
    "name": "AccountBrandsPanelQuery",
    "operationKind": "query",
    "text": "query AccountBrandsPanelQuery(\n  $input: AdminListBrandsRequest!\n) {\n  adminListBrands(input: $input) {\n    data {\n      id\n      name\n      metaAdAccountExternalId\n      featureFlagIds\n      currencyType\n      fbAccessTokenType\n      dataGranularity\n      minAdSpend\n      insightsThreshold\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2ba9785a60d356b6dd314e632c9929d";

export default node;
